import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import ListItem from "@material-ui/core/ListItem";
import moment from "moment";

import { useStyles } from "./ViewStudentAttendance.css";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import AttendanceBody from "../AttendanceBody/AttendanceBody";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class ViewStudentAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Admission No." },
        { name: "Student Name" },
        { name: "Status" },
        { name: "Remarks" },
        { name: "Actions" },
      ],
      date: moment(new Date()).format("YYYY-MM-DD"),
      studentAttendanceList: [],
    };
  }

  componentDidMount() {
    this.getStudentAttendance();
  }

  getStudentAttendance = async () => {
    try {
      const response = await Axios.get(`${url}/api/student-attendance`, {
        params: {
          date: moment(new Date()).format("YYYY-MM-DD"),
        },
        headers: { Authorization: `Bearer ${this.props.adminToken}` },
      });
      let studentList = [];
      let filteredData = response.data.attendances.filter((data) => {
        return this.props.config.faculty && this.props.config.group
          ? data.studentId.studentClass.indexOf(this.props.config.class) !==
              -1 &&
              data.studentId.faculty.indexOf(this.props.config.faculty) !==
                -1 &&
              data.studentId.group.indexOf(this.props.config.group) !== -1 &&
              data.studentId.section.indexOf(this.props.config.section) !== -1
          : data.studentId.studentClass.indexOf(this.props.config.class) !==
              -1 &&
              data.studentId.section.indexOf(this.props.config.section) !== -1;
      });
      if (filteredData.length !== 0) {
        for (let i = 0; i <= filteredData.length - 1; i++) {
          studentList.push({
            attendanceId: filteredData[i]._id,
            studentId: filteredData[i].studentId,
            admissionId: filteredData[i].admissionId,
            status: filteredData[i].status,
            date: filteredData[i].date,
          });
        }
        this.setState({
          studentAttendanceList: filteredData,
        });
      } else {
        let data = [];
        for (let i = 0; i <= this.props.studentList.length - 1; i++) {
          data.push({
            studentId: this.props.studentList[i].studentId,
            admissionId: this.props.studentList[i].admissionId,
            status: this.props.studentList[i].status,
            date: this.props.studentList[i].date,
          });
        }
        const bulkWriteResponse = await Axios.put(
          `${url}/api/student-attendance/bulk`,
          { studentAttendances: data },
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (bulkWriteResponse.data.message === "Bulk attendance successfull") {
          this.getStudentAttendance();
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudentAttendance();
      }
    }
  };

  render() {
    const { classes, config } = this.props;
    return (
      <div>
        <div>Daily Attendance - {moment(this.state.date).format("LL")}</div>
        <div className={classes.listitemRoot}>
          <div className={classes.listitemContent}>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Session</b>
              <div>{config.session}</div>
            </ListItem>

            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Group</b>
              <div>{config.group ? config.group : "N/A"}</div>
            </ListItem>
          </div>
          <div className={classes.listitemContent}>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Class</b>
              <div>{config.class}</div>
            </ListItem>

            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Section</b>
              <div>{config.section}</div>
            </ListItem>
          </div>
          <div className={classes.listitemContent}>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Faculty</b>
              <div>{config.faculty ? config.faculty : "N/A"}</div>
            </ListItem>
          </div>
        </div>
        <TableContainer>
          <Table>
            <CustomTableHead column={this.state.column} />

            <TableBody>
              {this.state.studentAttendanceList.length !== 0 &&
                this.state.studentAttendanceList.map((student, index) => (
                  <AttendanceBody
                    key={index}
                    index={index}
                    data={student}
                    getStudentAttendance={this.getStudentAttendance}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewStudentAttendance)));
